import { AppBar, Box, Button, Toolbar, Menu, MenuItem, ListItemIcon, ListItemText, Divider, IconButton, Grid, FormControl, TextField, Typography } from "@mui/material";

// icons
import ApprovalIcon from '@mui/icons-material/Approval';
import Close from '@mui/icons-material/Close';
import DoneIcon from '@mui/icons-material/Done';
import HelpIcon from '@mui/icons-material/ContactSupport';
import Cancel from '@mui/icons-material/CancelOutlined';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ImportExportIcon from '@mui/icons-material/ImportExport';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import ListAltIcon from '@mui/icons-material/ListAlt';
import RefreshIcon from '@mui/icons-material/Refresh';
import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import AddIcon from '@mui/icons-material/Add';
import Searchicon from '@mui/icons-material/Search';
import UpdateIcon from '@mui/icons-material/Update';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import SummarizeIcon from '@mui/icons-material/Summarize';

import PauseCircleOutlinedIcon from '@mui/icons-material/PauseCircleOutlined';
import DoneOutlinedIcon from '@mui/icons-material/Pending'; //single
import DoneAllOutlinedIcon from '@mui/icons-material/DoneAllOutlined';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';

import { useState } from "react";

import { hasPermission } from '../../../components/user-permission/AuthorizationParameter';
import useUserPermissions from '../../../components/user-permission/UserPermission';

// Date picker components
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { styled } from '@mui/material/styles';

// Utilities
import dayjs from 'dayjs';
import 'dayjs/plugin/customParseFormat';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import qrcode from 'qrcode';
import { useTranslation } from 'react-i18next';
import GlobalConfig from "../../../config/date/GlobalConfig";
import AddWinderProcess from "./AddNewWinderProcess";

const WinderSummaryList = ({ handleBackWinderMachineEntry }) => {
    const userPermissions = useUserPermissions();

    // First Menu States
    const [anchorElFirst, setAnchorElFirst] = useState(null);
    const [selectedOptionFirst, setSelectedOptionFirst] = useState('Winder Process');
    const openFirst = Boolean(anchorElFirst);

    // Second Menu States
    const [anchorElSecond, setAnchorElSecond] = useState(null);
    const openSecond = Boolean(anchorElSecond);

    //
    const [selectedStatus, setSelectedStatus] = useState('All');

    // filter date and time 
    const [filterFromDate, setFilterFromDate] = useState(dayjs().subtract(GlobalConfig.defaultDays, 'day').format('DD/MMM/YYYY'));
    const [filterToDate, setFilterToDate] = useState(dayjs().format('DD/MMM/YYYY'));

    // page view
    const [viewSummary, setViewSummary] = useState(true);


    // Handlers for first menu
    const handleMenuClickFirst = (event) => {
        setAnchorElFirst(event.currentTarget);
    };

    const handleMenuCloseFirst = () => {
        setAnchorElFirst(null);
    };




    const handleMenuItemClickFirst = (option) => {

        // Map the options to status
        const statusMap = {
            'All Parent Roll List': 'All',
            'Inprogress Parent Roll': 'booked',
            'Cancelled Parent Roll': 'cancelled',
        };

        setSelectedOptionFirst(option); // Update the selected option
        setSelectedStatus(statusMap[option] || selectedStatus);
        handleMenuCloseFirst();// Close the menu        
    };

    const handleShowNewVendor = () => {
        setViewSummary(false);
    };

    const handleMenuItemClickSecond = (option) => {
    };

    const handleShowQcPassModel = () => {
    };
    const handleViewMAWiseBalanceQty = () => {
    };
    const handleMenuClickSecond = (event) => {
    };
    const handleMenuCloseSecond = () => {
    };

    // filter options 

    const handleFilterFromDate = (date) => {
        setFilterFromDate(dayjs(date));
    };

    const handleFilterToDate = (date) => {
        setFilterToDate(dayjs(date));
    };

    const handleCallBack = () => {
        setViewSummary(true);
    };



    return (<Box>

        {viewSummary && (<>
            <AppBar position="static" sx={{ backgroundColor: "inherit", borderRadius: "0px", height: "48px", justifyContent: "center" }}>
                <Toolbar>
                    {/* First Menu */}
                    <Button
                        color="secondary"
                        onClick={handleMenuClickFirst}
                        endIcon={<ExpandMoreIcon sx={{ color: "teal", fontSize: "18px" }} />}
                        sx={{ textTransform: 'none', fontSize: "16px", fontWeight: "500" }}
                    >
                        {selectedOptionFirst}
                    </Button>

                    <Menu
                        anchorEl={anchorElFirst}
                        open={openFirst}
                        onClose={handleMenuCloseFirst}

                    >
                        <MenuItem onClick={() => handleMenuItemClickFirst('All Parent Roll List')}>All ParentRoll</MenuItem>
                        <MenuItem onClick={() => handleMenuItemClickFirst('Inprogress Parent Roll')}>Inprogress Parent Roll</MenuItem>
                        <MenuItem onClick={() => handleMenuItemClickFirst('Cancelled Parent Roll')}>Cancelled Parent Roll</MenuItem>
                    </Menu>

                    {/* Adding margin-left: auto to push the button to the right */}

                    {hasPermission(userPermissions, "Paper Machine Production", "Create") && (
                        <Button size="small" variant="contained" onClick={handleShowNewVendor} color="secondary" startIcon={<AddIcon sx={{ fontSize: "18px" }} />} sx={{ marginLeft: 'auto', textTransform: 'none' }}>New</Button>

                    )}
                    <Button size="small" variant="contained" onClick={handleShowQcPassModel} color="secondary" startIcon={<ApprovalIcon sx={{ fontSize: "18px" }} />} sx={{ ml: '5px', textTransform: 'none' }}>QC Approval</Button>
                    <Button size="small" variant="contained" onClick={handleViewMAWiseBalanceQty} color="secondary" startIcon={<SummarizeIcon sx={{ fontSize: "18px" }} />} sx={{ ml: '5px', textTransform: 'none' }}>View MA Wise Balance Qty</Button>

                    {/* Second Menu */}
                    <IconButton
                        size="small"
                        aria-label="menu"
                        sx={{ ml: 2 }}
                        onClick={handleMenuClickSecond}
                    >
                        <MoreVertIcon sx={{ fontSize: "18px" }} />
                    </IconButton>
                    <Menu
                        anchorEl={anchorElSecond}
                        open={openSecond}
                        onClose={handleMenuCloseSecond}
                    >
                        <MenuItem onClick={() => handleMenuItemClickSecond('Import Vendors')}>
                            <ListItemIcon>
                                <ImportExportIcon />
                            </ListItemIcon>
                            <ListItemText primary="Import Vendors" />
                        </MenuItem>
                        <MenuItem onClick={() => handleMenuItemClickSecond('Export Vendors')}>
                            <ListItemIcon>
                                <FileDownloadIcon />
                            </ListItemIcon>
                            <ListItemText primary="Export Vendors" />
                        </MenuItem>
                        <Divider />
                        <MenuItem onClick={() => handleMenuItemClickSecond('Export Current View')}>
                            <ListItemIcon>
                                <ViewColumnIcon />
                            </ListItemIcon>
                            <ListItemText primary="Export Current View" />
                        </MenuItem>
                        <Divider />
                        <MenuItem onClick={() => handleMenuItemClickSecond('Preference List')}>
                            <ListItemIcon>
                                <ListAltIcon />
                            </ListItemIcon>
                            <ListItemText primary="Preference " />
                        </MenuItem>
                        <Divider />
                        <MenuItem onClick={() => handleMenuItemClickSecond('Refresh List')}>
                            <ListItemIcon>
                                <RefreshIcon />
                            </ListItemIcon>
                            <ListItemText primary="Refresh List" />
                        </MenuItem>
                        <Divider />
                        <MenuItem onClick={() => handleMenuItemClickSecond('Reset Column Width')}>

                            <Button variant="contained" color="secondary" size="small" startIcon={<FormatAlignJustifyIcon />}>
                                Reset Columns Width
                            </Button>
                        </MenuItem>
                    </Menu>

                    <IconButton
                        size="small"
                        aria-label="menu"
                        sx={{ mr: 1, ml: 1 }}
                        onClick={handleMenuClickSecond}
                    >
                        <HelpIcon sx={{ fontSize: "18px" }} />
                    </IconButton>

                    <div>
                        <IconButton onClick={handleBackWinderMachineEntry} >
                            <Close sx={{ fontSize: "18px", color: "#2196F3" }} />
                        </IconButton>
                    </div>

                </Toolbar>
            </AppBar>

            <Grid container padding="5px 0px 5px 5px" alignItems="center" sx={{ mt: 0, mb: 0, pt: 0, pb: 0, justifyContent: "flex-end" }} >
                {/* <Grid item xs={12} sm={12} md={1} lg={4} xl={2.8} mt="5px" display="flex-start" justifyContent="center">
                                               <Button>
                                                View MA Wise Balance Plan Qty
                                                </Button>                                         
                                            </Grid> */}


                <Grid item xs={2} sm={3} md={1.5} lg={1.5} xl={1} mt="5px">
                    <FormControl fullWidth size="small">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DatePicker
                                style={{ marginLeft: '10px' }}
                                id="FromDate"
                                value={dayjs(filterFromDate)}
                                onChange={(date) => handleFilterFromDate(date)}

                                slotProps={{
                                    textField: {
                                        size: 'small',
                                        variant: 'standard', // Removes the filled/outlined border
                                        InputProps: {
                                            disableUnderline: true, // Remove underline from 'standard' variant
                                        },
                                        sx: {
                                            backgroundColor: 'transparent',
                                            padding: 0,
                                            '& .MuiInputBase-root': {
                                                border: 'none',
                                            },
                                            '& .MuiSvgIcon-root': {
                                                fontSize: '18px', // 👈 smaller icon size
                                            },
                                            '& .MuiInputBase-root': {
                                                paddingRight: '6px', // optional: reduce padding around icon
                                            },
                                        },
                                    }
                                }}
                                renderInput={(props) => <TextField {...props} />}
                                autoFocus
                                format="DD-MMM-YYYY"
                            />
                        </LocalizationProvider>
                    </FormControl>
                </Grid>
                <Grid item mt="5px" ml="10px" mr="10px">
                    <Typography fontWeight="bold">-</Typography>
                </Grid>


                <Grid item xs={2} sm={3} md={1.5} lg={1.5} xl={1} mt="5px" mr="10px">
                    <FormControl fullWidth size="small" >
                        <LocalizationProvider dateAdapter={AdapterDayjs} style={{ marginLeft: '10px' }}>
                            <DatePicker
                                id="ToDate"
                                value={dayjs(filterToDate)}
                                format="DD-MMM-YYYY"
                                onChange={(date) => handleFilterToDate(date)}
                                // slotProps={{ textField: { size: 'small', } }}
                                slotProps={{
                                    textField: {
                                        size: 'small',
                                        variant: 'standard', // Removes the filled/outlined border
                                        InputProps: {
                                            disableUnderline: true, // Remove underline from 'standard' variant
                                        },
                                        sx: {
                                            backgroundColor: 'transparent',
                                            padding: 0,
                                            '& .MuiInputBase-root': {
                                                border: 'none',
                                            },
                                            '& .MuiSvgIcon-root': {
                                                fontSize: '18px', // 👈 smaller icon size
                                            },
                                            '& .MuiInputBase-root': {
                                                paddingRight: '6px', // optional: reduce padding around icon
                                            },
                                        },
                                    }
                                }}
                                renderInput={(props) => <TextField {...props} />}
                            />
                        </LocalizationProvider>
                    </FormControl>
                </Grid>


            </Grid>

        </>) || (<>
            <AddWinderProcess editPartyID={0} callback={handleCallBack} />
        </>)}
    </Box>)
}
export default WinderSummaryList;





// import React, { useEffect, useMemo, useState } from "react";

// // WinderProcess.jsx
// // Single-file React component with Tailwind CSS for styling.
// // - Two-column responsive layout
// // - Grouped fields: Date range, Parent Roll, Shift, Winder Operator
// // - MO/MA summary card on the right
// // - Simple stepper (3 steps)
// // - Local validation & preview

// export default function WinderSummaryList() {
//   // Form state
//   const [dateFrom, setDateFrom] = useState(() => formatDate(addDays(new Date(), -7)));
//   const [dateTo, setDateTo] = useState(() => formatDate(new Date()));
//   const [parentRoll, setParentRoll] = useState("");
//   const [shiftDate, setShiftDate] = useState(() => formatDate(new Date()));
//   const [shiftCode, setShiftCode] = useState("A");
//   const [operator, setOperator] = useState("");
//   const [joinAnother, setJoinAnother] = useState(false);

//   // Stepper
//   const [step, setStep] = useState(1);

//   // Mock operator list and parent roll suggestions (would normally come from API)
//   const operators = ["thiravidam", "kumar", "anita", "raj"];
//   const parentRollSuggestions = ["25F0001", "25F0002", "26R1001", "26R1002"];

//   // MO/MA derived details (mock implementation)
//   const [moDetails, setMoDetails] = useState(null);
//   const [loadingMODetails, setLoadingMODetails] = useState(false);

//   // preview / result
//   const [result, setResult] = useState(null);

//   // Fetch/derive MO details when parentRoll changes
//   useEffect(() => {
//     let mounted = true;
//     if (!parentRoll) {
//       setMoDetails(null);
//       return;
//     }
//     setLoadingMODetails(true);
//     // simulate fetch
//     const t = setTimeout(() => {
//       if (!mounted) return;
//       setMoDetails(mockMODetailsFor(parentRoll));
//       setLoadingMODetails(false);
//     }, 450);
//     return () => {
//       mounted = false;
//       clearTimeout(t);
//     };
//   }, [parentRoll]);

//   // derived combination compact display
//   const comboShort = useMemo(() => {
//     if (!moDetails) return "-";
//     const combo = moDetails.combination || "";
//     return combo.length > 36 ? combo.slice(0, 34) + "…" : combo;
//   }, [moDetails]);

//   // simple validation
//   function validateForm() {
//     const errors = {};
//     if (!parentRoll) errors.parentRoll = "Parent Roll required";
//     if (!operator) errors.operator = "Operator required";
//     if (new Date(dateFrom) > new Date(dateTo)) errors.dateRange = "From must be before To";
//     return errors;
//   }

//   function handleNext() {
//     const errors = validateForm();
//     if (Object.keys(errors).length > 0) {
//       // If validation fails, show first issue via alert for simplicity
//       alert(Object.values(errors)[0]);
//       return;
//     }
//     setStep((s) => Math.min(3, s + 1));
//   }

//   function handleBack() {
//     setStep((s) => Math.max(1, s - 1));
//   }

//   function handleSubmit(e) {
//     e?.preventDefault();
//     const errors = validateForm();
//     if (Object.keys(errors).length > 0) return alert(Object.values(errors)[0]);

//     // Build payload (example)
//     const payload = {
//       dateFrom,
//       dateTo,
//       parentRoll,
//       shiftDate,
//       shiftCode,
//       operator,
//       joinAnother,
//       moDetails,
//     };

//     // Mock submit — in real app send to API
//     setResult({ ok: true, payload, createdAt: new Date().toISOString() });
//     setStep(3);
//   }

//   return (
//     <div className="p-6 max-w-7xl mx-auto">
//       {/* Stepper */}
//       <Stepper step={step} />

//       <form onSubmit={handleSubmit} className="mt-6 grid grid-cols-1 lg:grid-cols-12 gap-6">
//         {/* Left: form (span 7/12) */}
//         <div className="lg:col-span-8 space-y-6">
//           <section className="bg-slate-800 rounded-xl p-4 shadow-sm border border-slate-700">
//             <h3 className="text-slate-200 font-semibold mb-3">Parent Roll & Shift</h3>

//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//               <div className="space-y-2">
//                 <label className="text-slate-300 text-xs">Date Range</label>
//                 <div className="flex gap-2">
//                   <input
//                     type="date"
//                     className="bg-slate-900 border border-slate-700 px-3 py-2 rounded w-full"
//                     value={dateFrom}
//                     onChange={(e) => setDateFrom(e.target.value)}
//                   />
//                   <input
//                     type="date"
//                     className="bg-slate-900 border border-slate-700 px-3 py-2 rounded w-full"
//                     value={dateTo}
//                     onChange={(e) => setDateTo(e.target.value)}
//                   />
//                 </div>
//               </div>

//               <div className="space-y-2">
//                 <label className="text-slate-300 text-xs">Parent Roll Number</label>
//                 <input
//                   list="parent-rolls"
//                   className="bg-slate-900 border border-slate-700 px-3 py-2 rounded w-full"
//                   placeholder="Enter or pick..."
//                   value={parentRoll}
//                   onChange={(e) => setParentRoll(e.target.value)}
//                 />
//                 <datalist id="parent-rolls">
//                   {parentRollSuggestions.map((p) => (
//                     <option key={p} value={p} />
//                   ))}
//                 </datalist>
//               </div>

//               <div className="space-y-2">
//                 <label className="text-slate-300 text-xs">Shift Date / Code</label>
//                 <div className="flex gap-2">
//                   <input
//                     type="date"
//                     className="bg-slate-900 border border-slate-700 px-3 py-2 rounded w-full"
//                     value={shiftDate}
//                     onChange={(e) => setShiftDate(e.target.value)}
//                   />
//                   <select
//                     className="bg-slate-900 border border-slate-700 px-3 py-2 rounded w-28"
//                     value={shiftCode}
//                     onChange={(e) => setShiftCode(e.target.value)}
//                   >
//                     <option value="A">A</option>
//                     <option value="B">B</option>
//                     <option value="C">C</option>
//                   </select>
//                 </div>
//               </div>

//               <div className="space-y-2">
//                 <label className="text-slate-300 text-xs">Winder Operator</label>
//                 <div className="flex gap-2">
//                   <select
//                     className="bg-slate-900 border border-slate-700 px-3 py-2 rounded w-full"
//                     value={operator}
//                     onChange={(e) => setOperator(e.target.value)}
//                   >
//                     <option value="">Select operator</option>
//                     {operators.map((op) => (
//                       <option key={op} value={op}>
//                         {op}
//                       </option>
//                     ))}
//                   </select>
//                   <button
//                     type="button"
//                     className="px-3 py-2 rounded bg-slate-700 text-white text-sm"
//                     onClick={() => alert("Open operator quick-add (replace with modal)")}
//                   >
//                     +
//                   </button>
//                 </div>
//               </div>

//               <div className="md:col-span-2 flex items-center gap-3">
//                 <input
//                   id="joinAnother"
//                   type="checkbox"
//                   checked={joinAnother}
//                   onChange={(e) => setJoinAnother(e.target.checked)}
//                   className="h-4 w-4 rounded bg-slate-900 border-slate-600"
//                 />
//                 <label htmlFor="joinAnother" className="text-slate-300 text-sm">
//                   Join Another Parent Roll
//                 </label>
//               </div>
//             </div>

//             <div className="mt-4 flex gap-3">
//               <button
//                 type="button"
//                 onClick={handleNext}
//                 className="px-4 py-2 rounded bg-indigo-600 hover:bg-indigo-500 text-white"
//               >
//                 Next
//               </button>
//               <button
//                 type="button"
//                 onClick={() => { setParentRoll(""); setOperator(""); }}
//                 className="px-4 py-2 rounded bg-slate-700 text-slate-200"
//               >
//                 Reset
//               </button>
//             </div>
//           </section>

//           {/* Step 2: confirmation / details */}
//           {step >= 2 && (
//             <section className="bg-slate-800 rounded-xl p-4 shadow-sm border border-slate-700">
//               <h3 className="text-slate-200 font-semibold mb-3">Production & Confirmation</h3>

//               <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//                 <div className="md:col-span-2">
//                   <label className="text-slate-300 text-xs">Notes</label>
//                   <textarea className="bg-slate-900 border border-slate-700 rounded w-full p-2 h-24" placeholder="Optional production notes" />
//                 </div>

//                 <div>
//                   <label className="text-slate-300 text-xs">Planned Sets</label>
//                   <input type="number" className="bg-slate-900 border border-slate-700 px-3 py-2 rounded w-full" placeholder="e.g. 35" />
//                 </div>
//               </div>

//               <div className="mt-4 flex gap-3 justify-between">
//                 <div>
//                   <button type="button" onClick={handleBack} className="px-3 py-2 rounded bg-slate-700 text-slate-200 mr-2">
//                     Back
//                   </button>
//                   <button type="submit" className="px-4 py-2 rounded bg-green-600 text-white">
//                     Start Production
//                   </button>
//                 </div>

//                 <div className="text-slate-400 text-sm">Preview will be created after submission.</div>
//               </div>
//             </section>
//           )}

//           {/* Step 3: result preview */}
//           {step === 3 && result && (
//             <section className="bg-slate-900 rounded-xl p-4 shadow-sm border border-slate-700">
//               <h3 className="text-slate-100 font-semibold mb-2">Result</h3>
//               <pre className="text-xs text-slate-300 bg-slate-800 p-3 rounded max-h-48 overflow-auto">{JSON.stringify(result, null, 2)}</pre>
//             </section>
//           )}
//         </div>

//         {/* Right: MO/MA details (span 4/12) */}
//         <aside className="lg:col-span-4">
//           <div className="sticky top-6">
//             <div className="bg-slate-800 rounded-xl p-4 shadow border border-slate-700">
//               <div className="flex items-center gap-3 mb-3">
//                 <div className="rounded-full bg-indigo-500 w-9 h-9 flex items-center justify-center text-white font-bold">i</div>
//                 <h4 className="text-slate-100 font-semibold">Selected Parent Roll MO & MA</h4>
//               </div>

//               <div className="bg-slate-900 rounded p-3 text-sm text-slate-300">
//                 {loadingMODetails && <div className="italic">Loading details…</div>}

//                 {!loadingMODetails && !moDetails && (
//                   <div className="text-slate-500">No MO/MA selected. Choose a Parent Roll to load details.</div>
//                 )}

//                 {moDetails && (
//                   <div className="space-y-2">
//                     <dl className="grid grid-cols-2 gap-y-1">
//                       <dt className="text-slate-400 text-xs">Selected MO #</dt>
//                       <dd className="text-slate-100 text-sm">{moDetails.mo}</dd>

//                       <dt className="text-slate-400 text-xs">MA #</dt>
//                       <dd className="text-slate-100 text-sm">{moDetails.ma}</dd>

//                       <dt className="text-slate-400 text-xs">Combination</dt>
//                       <dd className="text-slate-100 text-sm break-words">{comboShort}</dd>

//                       <dt className="text-slate-400 text-xs">Total Sets</dt>
//                       <dd className="text-slate-100 text-sm">{moDetails.totalSets}</dd>

//                       <dt className="text-slate-400 text-xs">Produced Sets</dt>
//                       <dd className="text-slate-100 text-sm">{moDetails.producedSets}</dd>
//                     </dl>

//                     {/* show full combo in chip list */}
//                     <div className="mt-3">
//                       <label className="text-slate-400 text-xs">Combination chips</label>
//                       <div className="mt-2 flex flex-wrap gap-2">
//                         {moDetails.chunks.map((c, i) => (
//                           <span key={i} className="px-2 py-1 rounded-full bg-slate-700 text-slate-100 text-xs">
//                             {c}
//                           </span>
//                         ))}
//                       </div>
//                     </div>

//                     <div className="mt-3 flex gap-2">
//                       <button
//                         type="button"
//                         onClick={() => alert('Open MO details modal (implement)')}
//                         className="px-3 py-1 rounded bg-indigo-600 text-white text-sm"
//                       >
//                         View
//                       </button>
//                       <button
//                         type="button"
//                         onClick={() => { navigator.clipboard?.writeText(JSON.stringify(moDetails)); alert('Copied'); }}
//                         className="px-3 py-1 rounded bg-slate-700 text-slate-100 text-sm"
//                       >
//                         Copy
//                       </button>
//                     </div>
//                   </div>
//                 )}
//               </div>
//             </div>

//             {/* Quick actions card */}
//             <div className="mt-4 bg-slate-800 rounded-xl p-3 border border-slate-700">
//               <h5 className="text-slate-200 text-sm font-medium mb-2">Quick Actions</h5>
//               <div className="flex flex-col gap-2">
//                 <button className="px-3 py-2 rounded bg-slate-700 text-slate-200 text-sm" onClick={() => setParentRoll(parentRollSuggestions[0])}>
//                   Load sample roll
//                 </button>
//                 <button className="px-3 py-2 rounded bg-slate-700 text-slate-200 text-sm" onClick={() => setMoDetails(null)}>
//                   Clear MO details
//                 </button>
//               </div>
//             </div>
//           </div>
//         </aside>
//       </form>
//     </div>
//   );
// }

// // ---------- Helper UI pieces ----------
// function Stepper({ step = 1 }) {
//   const labels = ["Select", "Confirm", "Run"];
//   return (
//     <div className="flex items-center gap-4">
//       {labels.map((label, i) => {
//         const active = i + 1 === step;
//         const done = i + 1 < step;
//         return (
//           <div key={label} className="flex items-center gap-3">
//             <div className={`w-8 h-8 rounded-full flex items-center justify-center ${active ? 'bg-indigo-600 text-white' : done ? 'bg-green-600 text-white' : 'bg-slate-700 text-slate-300'}`}>
//               {i + 1}
//             </div>
//             <div className={`text-sm ${active ? 'text-slate-100 font-medium' : 'text-slate-400'}`}>{label}</div>
//             {i !== labels.length - 1 && <div className="w-6 h-px bg-slate-700 mx-2" />}
//           </div>
//         );
//       })}
//     </div>
//   );
// }

// // ---------- Mock & util functions ----------
// function mockMODetailsFor(parentRoll) {
//   // deterministic mock for demos
//   const base = parentRoll.replace(/[^0-9]/g, '') || '0001';
//   const mo = String(5200 + (parseInt(base.slice(-3)) % 100)).padStart(4, '0');
//   const ma = String(8500 + (parseInt(base.slice(-2)) % 100)).padStart(4, '0');
//   const pieces = ["(91X1)", "(76X1)", "(61X1)", "(86X1)", "(51X1)"];
//   const chunks = pieces.map((p, i) => `${p.split(')')[0]})/R${i}`);
//   const combination = pieces.join('+');
//   const totalSets = (parseInt(base.slice(-2)) % 50) + 5;
//   const producedSets = Math.floor(totalSets * 0.0);

//   return {
//     mo,
//     ma,
//     combination,
//     chunks,
//     totalSets,
//     producedSets,
//   };
// }

// function addDays(d, n) {
//   const c = new Date(d);
//   c.setDate(c.getDate() + n);
//   return c;
// }

// function formatDate(d) {
//   if (!d) return '';
//   const dt = new Date(d);
//   const y = dt.getFullYear();
//   const m = String(dt.getMonth() + 1).padStart(2, '0');
//   const day = String(dt.getDate()).padStart(2, '0');
//   return `${y}-${m}-${day}`;
// }
